import { render } from "./AssetsMap.vue?vue&type=template&id=54dc3e89&scoped=true&ts=true"
import script from "./AssetsMap.vue?vue&type=script&lang=ts"
export * from "./AssetsMap.vue?vue&type=script&lang=ts"

import "./AssetsMap.vue?vue&type=style&index=0&id=54dc3e89&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dc3e89"]])

export default __exports__